<template>
  <div class="modal offer-modal skin-modal contact-info-modal">
    <div class="overlay" @click="close"></div>
    <div class="wrapper">
      <img class="close" @click="close" src="./../assets/close.svg" />
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title title-24">
                <b>CONTACT INFORMATION</b>
              </div>
              <div class="form-fields-wrapper" v-if="step == 1">
                <div class="input-container">
                  <div class="desc">Name:</div>
                  <input type="text" placeholder="Name" v-model="name" />
                </div>
                <div class="input-container">
                  <div class="desc">Surname:</div>
                  <input type="text" placeholder="Surname" v-model="surname" />
                </div>
                <div class="input-container">
                  <div class="desc">E-mail address:</div>
                  <input
                    type="email"
                    placeholder="E-mail address"
                    v-model="email"
                  />
                </div>
                <div class="input-container">
                  <div class="desc">Phone:</div>
                  <input type="tel" placeholder="Phone" v-model="phone" />
                </div>
                <div class="input-container">
                  <div class="desc">Country:</div>
                  <Select2
                    class="select2 single"
                    v-model="country"
                    :options="countryOptions"
                    @select="handleCountryChange($event)"
                    placeholder="Country"
                  />
                </div>
                <div class="input-container">
                  <div class="desc">City:</div>
                  <input type="text" placeholder="City" v-model="city" />
                </div>
                <div class="input-container">
                  <div class="desc">Address:</div>
                  <input type="text" placeholder="Address" v-model="address" />
                </div>
                <div class="input-container">
                  <div class="desc">Post Code:</div>
                  <input
                    type="text"
                    placeholder="Post Code"
                    v-model="postCode"
                  />
                </div>
              </div>

              <div class="form-fields-wrapper" v-if="step == 2">
                <div class="cart-top cart-top-spec">
                  <div
                    @click="withdrawMethod = 'sepa'"
                    :class="[
                      'desc transfer-title',
                      { active: withdrawMethod == 'sepa' },
                    ]"
                  >
                    <b>IBAN TRANSFER</b>
                  </div>
                </div>

                <div
                  class="offer-wrapper topup-form"
                  v-if="withdrawMethod == 'sepa'"
                >
                  <div class="input-container">
                    <div class="desc">First Name:</div>
                    <input
                      type="text"
                      v-model="bank_holder_name"
                      placeholder="First Name"
                    />
                  </div>
                  <div class="input-container">
                    <div class="desc">Last Name:</div>
                    <input
                      type="text"
                      v-model="bank_holder_surname"
                      placeholder="Last Name"
                    />
                  </div>
                  <div class="input-container">
                    <div class="desc">IBAN Number:</div>
                    <input
                      type="text"
                      maxlength="29"
                      v-model="iban_number"
                      placeholder="IBAN"
                    />
                  </div>

                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="terms" v-model="terms" />
                        <div class="checkbox"></div>
                        <span class="title">I agree with </span>
                        <a @click="$parent.goToPage('privacy')" class="title"
                          >privacy policy</a
                        >
                        <span class="title"> and </span>
                        <a @click="$parent.goToPage('terms')" class="title"
                          >terms and conditions</a
                        >
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <transition name="slide">
                <div v-if="$parent.error" class="error-desc desc red">
                  {{ $parent.error }}
                </div>
              </transition>

              <div class="buttons buttons-special">
                <button
                  v-if="step == 1"
                  class="button orange-btn"
                  @click="closeAndGoBack"
                >
                  <span>Back</span>
                </button>
                <button
                  v-if="step == 1"
                  :class="['button', { disabled: !requiredFieldsAreFilled2 }]"
                  @click="step = 2"
                >
                  <span>Next</span>
                </button>

                <button
                  v-if="step == 2"
                  class="button orange-btn"
                  @click="step = 1"
                >
                  <span>Back</span>
                </button>

                <button
                  v-if="step == 2"
                  :class="['button', { disabled: !requiredFieldsAreFilled }]"
                  @click="confirm"
                >
                  <span>Confirm</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Select2 from "vue3-select2-component";

export default {
  name: "AcceptOfferModal",
  components: {
    Select2,
  },
  props: {
    orderToView: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      step: 1,
      card_holder_name: "",
      card_number: "",
      expire_month: "",
      expire_year: "",
      email: "",
      name: "",
      surname: "",
      phone: "",
      country: "",
      countryId: null,
      postCode: "",
      city: "",
      address: "",
      terms: false,
      iban: "",
      countryOptions: [],
      withdrawMethod: "sepa",
      iban_number: "",
      bank_holder_name: "",
      bank_holder_surname: "",
    };
  },
  mounted() {
    this.getCounties();
    this.$http
      .get(process.env.VUE_APP_API + "user/profile")
      .then((res) => {
        this.email = res.data.email;
        this.name = res.data.name;
        this.surname = res.data.surname;
        this.phone = res.data.phone;
      })
      .catch((res) => {
        if (res.response.status === 401) {
          this.$parent.openSignIn();
        }
      });
  },
  computed: {
    ...mapGetters("staticPages", ["getTermsPage", "getPrivacyPage"]),
    privacyPolicyUrl() {
      const privacyPage = this.getPrivacyPage;
      return privacyPage
        ? { name: "TextPage", params: { identifier: privacyPage.slug } }
        : null;
    },
    termsAndConditionsUrl() {
      const termsPage = this.getTermsPage;
      return termsPage
        ? { name: "TextPage", params: { identifier: termsPage.slug } }
        : null;
    },
    requiredFieldsAreFilled2() {
      return !!(
        this.name &&
        this.surname &&
        this.email &&
        this.phone &&
        this.country &&
        this.city &&
        this.address &&
        this.postCode
      );
    },
    requiredFieldsAreFilled() {
      // Basic required fields
      const basicFieldsFilled = !!(
        this.name &&
        this.surname &&
        this.email &&
        this.phone &&
        this.country &&
        this.city &&
        this.address &&
        this.postCode
      );

      // IBAN transfer specific fields
      const ibanFieldsFilled = !!(
        this.bank_holder_name &&
        this.bank_holder_surname &&
        this.iban_number
      );

      // Terms must be accepted
      const termsAccepted = this.terms;

      // All conditions must be met
      return basicFieldsFilled && ibanFieldsFilled && termsAccepted;
    },
  },
  methods: {
    closeAll() {
      this.$parent.closeAcceptOfferModal();
      this.$parent.closeOfferDetailsModal();
    },
    confirm() {
      const data = {
        offer_id: this.orderToView.id,
        id: this.orderToView.id,
        account_number: this.iban_number,
        first_name: this.bank_holder_name,
        last_name: this.bank_holder_surname,
        name: this.name,
        surname: this.surname,
        email: this.email,
        phone: this.phone,
        country: this.country,
        city: this.city,
        address: this.address,
        postCode: this.postCode,
        currency: this.$parent.currency,
      };

      this.$http
        .post(
          process.env.VUE_APP_API + "offer/withdraw/" + this.withdrawMethod,
          data
        )
        .then(() => {
          this.$parent.closeAcceptOfferModal();
          this.$parent.closeOfferDetailsModal();
          this.$router.push({ path: "/offer-accepted-succes" });
          this.$emit("setError", null); // Clear any previous errors
        })
        .catch((res) => {
          if (res.response.data.errors) {
            const firstErrors = {};
            for (const key in res.response.data.errors) {
              if (
                res.response.data.errors.hasOwnProperty(key) &&
                Array.isArray(res.response.data.errors[key]) &&
                res.response.data.errors[key].length > 0
              ) {
                firstErrors[key] = res.response.data.errors[key][0];
                this.$emit("setError", firstErrors[key]);
              }
            }
          } else {
            this.$emit("setError", res.response.data.message);
          }
        });
    },
    getCounties() {
      this.$http
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          // Transform the API response to Select2 format
          this.countryOptions = res.data.payload.map((country) => ({
            id: country.id,
            text: country.title,
          }));
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
    close() {
      this.$emit("closeAcceptOfferModal");
    },
    closeAndGoBack() {
      this.$parent.setError(null);
      this.$parent.closeAcceptOfferModal();
      this.$parent.openOfferDetailsModal(this.orderToView);
    },
    handleCountryChange(event) {
      if (event && event.id) {
        // Use the text property from the Select2 event directly
        this.country = event.text;
        this.countryId = event.id;
      }
    },
  },
};
</script>

<style scoped>
::v-deep .select2-container {
  width: 100% !important;
}

::v-deep .select2-container .select2-selection.select2-selection--single {
  height: 49px;
  border-bottom: 3px solid #495158;
  width: 100%;
}

::v-deep .select2-container #select2--container {
  line-height: 49px;
}

/* Override global Select2 width constraint */
::v-deep body .select2-container {
  width: 100% !important;
}

.input-container {
  width: 100%;
  margin-bottom: 12px;
}

.input-container input,
.input-container ::v-deep .select2-container {
  width: 100% !important;
  box-sizing: border-box;
}

.form-fields {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 42px 24px;
}

.form-fields-wrapper {
  width: 100%;
  max-width: 600px;
  margin: 32px auto 0;
}

.input-container {
  margin-bottom: 24px;
}

.input-container .desc {
  margin-bottom: 8px;
}

.form-fields-wrapper {
  max-width: 100%;
}

.modal .form-wrapper {
  width: 100%;
}

.modal .form-fields {
  width: 100%;
  max-width: 100%;
}

.form {
  width: 100%;
}

.transfer-title {
  font-size: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #495158;
  margin-bottom: 16px;
  cursor: pointer;
}

.transfer-title.active {
  color: #22d68d;
  border-bottom-color: #22d68d;
}

.offer-modal .offer-wrapper {
  padding-bottom: 5px;
}
.offer-modal .chekbox-label .title {
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #808a93;
}

.offer-modal .chekbox-label a.title {
  color: #22d68d;
  font-weight: 700;
}

@media screen and (max-width: 768px) {
  .form-fields {
    padding: 32px 16px;
  }

  .form-fields-wrapper {
    padding: 0;
  }

  .input-container {
    padding: 0;
  }

  .input-container .desc {
    width: 100%;
    margin-bottom: 8px;
  }

  .buttons {
    flex-direction: column;
    align-items: center;
  }

  .buttons button {
    width: 100%;
    max-width: 300px;
  }
}

@media screen and (max-width: 460px) {
  .form-fields {
    padding: 16px;
  }

  .form-fields-wrapper {
    margin-top: 24px;
  }

  input,
  ::v-deep .select2-container {
    font-size: 14px;
  }
}
</style>
